import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import config from '../../app-config';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private renderer: Renderer2;
  private currentThemeClass = '';
  isSidebarCollapsed = false;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  initTheme(orgId: string = config.defaultTheme) {
    this.applyTheme(orgId);
  }

  applyTheme(theme: string) {
    const host = document.body;
    const nextClass = `${theme}-theme`;

    if (this.currentThemeClass) {
      this.renderer.removeClass(host, this.currentThemeClass);
    }
    this.renderer.addClass(host, nextClass);
    this.currentThemeClass = nextClass;

    localStorage.setItem('theme', theme);
  }

  getTheme(): string {
    return (this.currentThemeClass || '').replace('-theme', '') || config.defaultTheme;
  }
}
